/*
* Add Filter classes here that represent a group of query param filters.
* The names of the attributes of the classes must be present in the QueryParamNames enum!
*/

export class VacancyFilterParams {
  absentTeacherId?: string;
}

export class TeacherFilterParams {
  searchTerm?: string;
}
